export const enum TemplateIds {
  PriceCalendar = 'priceCalendar',
  HotelDetailsImages = 'hotelDetailsImages',
  HotelDetailsInformation = 'hotelDetailsInformation',
  HotelDetailsRatings = 'hotelDetailsRatings',
  HotelDetailsLocation = 'hotelDetailsLocation',
  HotelDetailsStays = 'hotelDetailsStays',
  HotelDetailsHeader = 'hotelDetailsHeader',
}
